import { useEffect, useState } from 'react';
import Markdown from './Markdown';
import { MUSIC } from '../content/siteContent';
import Seo from "./Seo";

const SUPABASE_URL = 'https://mhkmgratcfxxfhnzkdld.supabase.co';
const ANON_KEY =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1oa21ncmF0Y2Z4eGZobnprZGxkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE2NzQwNDAsImV4cCI6MjA2NzI1MDA0MH0.0aQSAzEFskV65Snb3lwNHb0dTAtPmB43BLfJp8sO9MM';
const ENDPOINT = `${SUPABASE_URL}/functions/v1/spotify-now-playing`;

export default function Music() {
    const M = MUSIC;

    const [current, setCurrent] = useState(null);
    const [recent, setRecent] = useState([]);
    useEffect(() => {
        let active = true;
        const load = async () => {
            try {
                const res = await fetch(ENDPOINT, { headers: { apikey: ANON_KEY, Authorization: `Bearer ${ANON_KEY}` } });
                const data = await res.json();
                if (!active) return;
                setCurrent(data.current && data.current.title ? data.current : null);
                setRecent(Array.isArray(data.recent) ? data.recent : []);
            } catch { /* leave feed empty */ }
        };
        load();
        const id = setInterval(load, 30000);
        return () => { active = false; clearInterval(id); };
    }, []);

    const lately = [];
    if (current) lately.push({ ...current, playing: true });
    recent.forEach((t) => { if (lately.length < 6 && t && t.title) lately.push({ ...t, playing: false }); });

    return (
        <main className="cx-page"><div className="cx-col">
            <Seo title="Music" path="/music"
                 description="The music Ethan/Aris loves and sings; assistant music director of the Dartmouth Dodecaphonics." />

            <div className="cx-fade">
                {(M.title || M.intro) && (
                    <div className="mu-head">
                        {M.title && <h1>{M.title}</h1>}
                        {M.intro && <p className="intro">{M.intro}</p>}
                    </div>
                )}

                {M.prose && <div className="mu-prose"><Markdown>{M.prose}</Markdown></div>}

                {lately.length > 0 && (
                    <>
                        <p className="mu-label">{current ? 'Now playing' : 'Lately in my ears'}</p>
                        {lately.map((t, i) => (
                            <a key={i} className="mu-tr" href={t.url || '#'} target="_blank" rel="noreferrer">
                                {t.albumImage ? <img className="mu-tr-cover" src={t.albumImage} alt="" /> : <span className="mu-tr-cover" />}
                                <span className="mu-tr-line">
                                    {t.playing && <span className="cx-eq" aria-hidden="true"><span></span><span></span><span></span></span>}
                                    {t.title} <span className="a">— {t.artist}</span>
                                </span>
                            </a>
                        ))}
                    </>
                )}
            </div>
        </div></main>
    );
}
